import { Component, Inject, OnInit } from '@angular/core';
import { projectActions } from '@src/store/reducers/projectReducer';
import { Store } from '@src/store';
import { cloneDeep } from 'lodash';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { DialogManagerService } from '@src/services';
import { projectsActions } from '@src/store/reducers/projectsReducer';


@Component({
    selector: 'exclude-objects',
    template: require('./exclude-objects.component.html'),
    styles: [require('./exclude-objects.component.scss')]
})
export class ExcludeObjectsComponent implements OnInit {
    private readonly projectId: number;
    public dbFlags:any = null;
    public displayedColumns: any = [
        { name: 'DB Name', type: 'Combobox' }, { name: 'Operation', type: 'Combobox', key:'operationName' },{name:'Scope Type', type:'Combobox', key:'scopeTypeName' },
        { name: 'Schema/Owner Name', type: 'Textbox', key:'schemaName' }, { name: 'Object Name', type: 'Textbox' } ];

    public scopeTypeMap =  new Map([['Schema/Owner' , 0], ['Object Type' , 1], ['Object' , 2]]);
    public operationTypeMap = new Map([['Include' , 1], ['Exclude' , 2]]);
    public dataSource: any;
    public dataSourceTmp: any;
    public tmpDataSource: any;
    public translations;
    public newRow: any = {
        dBCId: 0,
        dbName: '',      
        operation: 2,          
        operationName: 'Exclude',
        scopeType: 0,
        scopeTypeName: 'Schema/Owner',
        schemaName: '',
        objectName: '',
        applyToBuild: true,
        applyToRollback: true,
        applyToValidate: true,
        applyToSourceControl: true
    };
    private rmSchemas: any;

    constructor(private store: Store,
                @Inject('$state') private state: any,
                @Inject('dbTypeService') private dbTypeService: any,
                private translatePipe: TranslatePipe,
                private dialogManagerService: DialogManagerService) {
        this.projectId = this.state.params.id;
    }

    public async ngOnInit() {
        this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR']).then(value => this.translations = value);
        const apiRequests = async (action: any) => await this.store.dispatch(
            { type: action, payload: { projectId: this.projectId } }
        );
        const projectsState = await this.store.getState().projects;            
        //oleg changed === to == need to fix later
        if(!projectsState.projectWithMetaData){
            var GetAllData = await this.store.dispatch(
                { type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.projectId } }
            );
            if(GetAllData && GetAllData.data){
                projectsState.projectWithMetaData = GetAllData.data;
            }
        }
        if (projectsState && projectsState.projectWithMetaData)
        {
            const tempDbTypeId = projectsState.projectWithMetaData.dbTypeId;
            this.dbFlags = await this.dbTypeService.getFlags(tempDbTypeId);
            if(this.dbFlags.HasDevEnv == true){
                this.displayedColumns.push({ name: 'Apply to SourceControl', type: 'Switch' , key:'applyToSourceControl' })
                this.displayedColumns.push({ name: 'Apply to Build', type: 'Switch', key:'applyToBuild' }) 
                this.displayedColumns.push({ name: 'Apply to Rollback', type: 'Switch' , key:'applyToRollback' })                
            }
            if(this.dbFlags.HasValidate == true){
                this.displayedColumns.push({ name: 'Apply to Validate', type: 'Switch', key:'applyToValidate'})
            }
        }
        this.rmSchemas = await apiRequests(projectActions.GET_RM_SCHEMAS);
        this.dataSourceTmp = await apiRequests(projectActions.GET_EXCLUDE_OBJECTS);
        this.dataSourceTmp.map((item) => {
            const dbName = this.rmSchemas.find(val => val.key === item.dBCId);
            item.dbName = (dbName) ? dbName.data : item.dBCId;
            //DB saves 
            //item.operation -= 1;
            //item.operationName = [...this.operationTypeMap].find(([key, val]) => val == 1)[0]
            //item.scopeTypeName = this.scopeTypeMap.get(item.scopeType);
            
        });        
        for (let i = 0; i < this.dataSourceTmp.length; i++) {
            var idx = Array.from( this.operationTypeMap.values() ).indexOf(this.dataSourceTmp[i].operation);
            this.dataSourceTmp[i].operationName = Array.from(this.operationTypeMap.keys())[idx];
            idx = Array.from( this.scopeTypeMap.values() ).indexOf(this.dataSourceTmp[i].scopeType);
            this.dataSourceTmp[i].scopeTypeName = Array.from(this.scopeTypeMap.keys())[idx];
        }
        this.dataSource = this.dataSourceTmp;
        
        this.displayedColumns.map((item) => {
            if (item.name === 'DB Name') {
                item.list = this.rmSchemas.map(a => a.data);
                item.placeholder = 'Choose DB Name';
            }
            if (item.key === 'scopeTypeName') {
                item.list = Array.from(this.scopeTypeMap.keys());
                //item.placeholder = item.scopeTypeName;
            }
            if (item.key === 'operationName') {
                item.list = Array.from(this.operationTypeMap.keys());
                //item.placeholder = item.operationName;
            }
        });

        //keep backup for cancel
        this.tmpDataSource = cloneDeep(this.dataSource);
    }

    public save(): void {
        this.dataSourceTmp = cloneDeep(this.dataSource);
        this.dataSourceTmp.map((item) => {
            item.operation = this.operationTypeMap.get(item.operationName);
            item.scopeType = this.scopeTypeMap.get(item.scopeTypeName);
        });   
        this.store.dispatch({
            type: projectActions.UPDATE_EXCLUDE_OBJECTS,
            payload: { projectId: this.projectId, excludeObjects: this.dataSourceTmp }
        })
            .then((data: any) => {
                if (data) {
                    this.tmpDataSource = cloneDeep(this.dataSource);
                    this.dialogManagerService.showSuccessDialog({ title: '', text: '' });
                } else {
                    this.dialogManagerService.showErrorDialog({
                        title: this.translations['ERROR'], 
                        text: this.translations['UNEXPECTED_ERROR']
                    });
                }
            });
    }

    public cancel(): void {
        this.dataSource = cloneDeep(this.tmpDataSource);
    }

    public selectValue(value): void {
        const { event, element, item } = value;
        if (item.name === 'DB Name') {
            const rmSchema = this.rmSchemas.find(v => v.data === event);
            element.dBCId = rmSchema.key;
        }
        if (item.key === 'scopeTypeName') {
            element.scopeType = this.scopeTypeMap.get(event);
            element.scopeTypeName = event;
        }
        if (item.key === 'operationName') {
            element.operation = this.operationTypeMap.get(event);
            element.operationName = event;
        }
    }

    public addNewRow(row): void {
        const keys = Object.keys(row);
        if (!keys) {
            return;
        }
        const newRow  = cloneDeep(this.newRow);
        keys.forEach((key) => {
            newRow[key] = row[key];
            if (key === 'dbName') {
                const rmSchema = this.rmSchemas.find(v => v.data === row[key]);
                newRow.dBCId = rmSchema.key;
            }
            if (key === 'scopeTypeName') {
                newRow.scopeType = this.scopeTypeMap.get(row[key]);
            }
            if (key === 'operationName') {
                newRow.operation = this.operationTypeMap.get(row[key]);
            }
        });
        this.dataSource.push(newRow);
    }

    public removeRow(element: any): void {
        this.dataSource.splice(this.dataSource.indexOf(element), 1);
    }

}

/*applyToBuild:true
applyToRollback:true
applyToSourceControl:true
applyToValidate:true
dBCId:1291
objectName:"'t_table2'"
operation:1
schemaName:""
scopeType:1
*/



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/exclude-objects/exclude-objects.component.ts